import { render, staticRenderFns } from "./PolicyConsent.vue?vue&type=template&id=3ddf57a0&scoped=true"
import script from "./PolicyConsent.vue?vue&type=script&lang=js"
export * from "./PolicyConsent.vue?vue&type=script&lang=js"
import style0 from "./PolicyConsent.vue?vue&type=style&index=0&id=3ddf57a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf57a0",
  null
  
)

export default component.exports